import React from "react";
import { useSelector } from 'react-redux';
import { DebounceInput } from 'react-debounce-input';
import { translate } from "../Services/translation";

export default function SearchInput(props) {

    const activeChannelId = useSelector((state) => state.channel.activeChannelId);

    const { itp, postValues } = props;

    const setSearchTerm = (value) => {
        if (value.replace(/\s/g, '').length || value == "") {
            let itemToSend = {
                channelId: activeChannelId,
                itemsPerPage: itp,
                searchTerm: value
            }
            postValues(`/api/mcs/searchitems`, itemToSend);   
        }
    }

    return (
        <>
            <div className="mcs__search-bar columns">
                <i className="fas fa-search"></i>
                <DebounceInput
                    minLength={1}
                    placeholder={translate("mcs.searchurl")}
                    debounceTimeout={500}
                    onChange={event => setSearchTerm(event.target.value)} />
            </div>
        </>
    );
}

